/** Ground-plane distance. Y is ignored — movement is flat (KTD3). */
export function distance2D(ax, az, bx, bz) {
    return Math.hypot(bx - ax, bz - az);
}
export function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
export function lerp(from, to, t) {
    return from + (to - from) * t;
}
/** Shortest signed delta between two angles in radians, in (-PI, PI]. */
export function angleDelta(from, to) {
    let delta = (to - from) % (Math.PI * 2);
    if (delta > Math.PI)
        delta -= Math.PI * 2;
    if (delta <= -Math.PI)
        delta += Math.PI * 2;
    return delta;
}
/** Interpolates angles the short way around the wrap point. */
export function lerpAngle(from, to, t) {
    return from + angleDelta(from, to) * t;
}
//# sourceMappingURL=math.js.map